import * as React from "react";
const SvgEdit = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      fillRule="evenodd"
      d="M21.456 5.416a.75.75 0 0 1-.096.943l-9.193 9.192a.75.75 0 0 1-.34.195l-3.83 1a.75.75 0 0 1-.914-.915l1-3.828a.778.778 0 0 1 .16-.312l9.228-9.22a.75.75 0 0 1 1.06 0l2.829 2.827a.758.758 0 0 1 .096.118m-1.687.412L18 4.061 9.483 12.58l-.625 2.393 2.393-.625z"
      clipRule="evenodd"
    />
    <path
      fill="#000"
      d="M19.642 17.16c.273-2.336.36-4.69.26-7.04a.403.403 0 0 1 .117-.3l.985-.984a.198.198 0 0 1 .337.127 45.903 45.903 0 0 1-.21 8.372c-.236 2.022-1.86 3.607-3.872 3.832a47.77 47.77 0 0 1-10.516 0c-2.012-.225-3.637-1.81-3.873-3.832a45.922 45.922 0 0 1 0-10.67c.236-2.022 1.86-3.607 3.873-3.832a47.75 47.75 0 0 1 7.989-.213.2.2 0 0 1 .128.34l-.993.992a.401.401 0 0 1-.298.117 46.162 46.162 0 0 0-6.66.255A2.89 2.89 0 0 0 4.36 6.84c-.4 3.428-.4 6.892 0 10.32a2.89 2.89 0 0 0 2.55 2.516c3.356.375 6.828.375 10.184 0a2.89 2.89 0 0 0 2.549-2.516"
    />
  </svg>
);
export default SvgEdit;
